import React from "react";
import { getProgressPoint } from "../../../helpers/bar-helper";
import { BarDisplay } from "./bar-display";
import { BarProgressHandle } from "./bar-progress-handle";
import { TaskItemProps } from "../task-item";
import styles from "./bar.module.css";
import { BarDateHandle } from "./bar-date-handle";

export const BarSmall = ({
  z,
  task,
  isProgressChangeable,
  isDateChangeable,
  onEventStart,
  isSelected,
}) => {
  const handleHeight = task.height - 2;
  const { x1, x2, y, handleWidth, barCornerRadius, styles: taskStyles } = task;
  const progressPoint = getProgressPoint(
    task.progressWidth + task.x1,
    task.y + z,
    task.height
  );
  return (
    <g className={styles.barWrapper} tabIndex={0}>
      <BarDisplay
        x={task.x1}
        y={task.y + z}
        width={task.x2 - task.x1}
        height={task.height}
        progressX={task.progressX}
        progressWidth={task.progressWidth}
        barCornerRadius={task.barCornerRadius}
        styles={task.styles}
        isSelected={isSelected}
        onMouseDown={(e) => {
          isDateChangeable && onEventStart("move", task, e);
        }}
      />
      <g className="handleGroup">
        {isDateChangeable && (
          <g>
            {/* left */}
            <BarDateHandle
              x={x1 + 1}
              y={y + z + 1}
              width={handleWidth}
              height={handleHeight}
              barCornerRadius={barCornerRadius}
              onMouseDown={(e) => {
                onEventStart("start", task, e);
              }}
            />
            {/* right */}
            <BarDateHandle
              x={x2 - handleWidth - 1}
              y={y + z + 1}
              width={handleWidth}
              height={handleHeight}
              barCornerRadius={barCornerRadius}
              onMouseDown={(e) => {
                onEventStart("end", task, e);
              }}
            />
          </g>
        )}
        {isProgressChangeable && (
          <BarProgressHandle
            progressPoint={progressPoint}
            onMouseDown={(e) => {
              onEventStart("progress", task, e);
            }}
          />
        )}
      </g>
    </g>
  );
};
